import { AMAZON } from '@/constants/amazon'
import { DeliveryService, MasterService } from '@/services'
import { add, startOfDay } from 'date-fns'
import { isValidPostalCode } from '@/utils'

export default {
  data() {
    const user = this.$store.state.auth.user || {}
    const date = user.birth ? new Date(user.birth * 1000) : null

    let postalCode = user.postal_code

    if (user.postal_code && !user.postal_code.includes(this.$t('common.hyphenSeparator'))) {
      const _code = user.postal_code.split('')
      _code.splice(3, 0, this.$t('common.hyphenSeparator'))
      postalCode = _code.join('')
    }

    const [postalCode1, postalCode2] = postalCode?.split(this.$t('common.hyphenSeparator')) || ['', '']

    const form = {
      memberInformation: {
        lastName: user.name01 || '',
        firstName: user.name02 || '',
        lastNameKana: user.kana01 || '',
        firstNameKana: user.kana02 || '',
        birthdayYear: date ? this.$date.getYear(date) : null,
        birthdayMonth: date ? this.$date.getMonth(date) + 1 : null,
        birthdayDay: date ? this.$date.getDate(date) : null,
        sex: user.sex?.id || null,
        email: user.email || '',
        emailConfirm: user.email || '',
        password: '' || user.password,
        passwordConfirm: '' || user.password,
        postalCode1: postalCode1 || '',
        postalCode2: postalCode2 || '',
        prefecture: user.pref?.id || null,
        municipality: user.addr01 || '',
        address: user.addr02 || '',
        buildingApartmentName: user.addr03 || '',
        phoneNumber: this.Utils.helper.getOnlyNumber(user.phone_number),
        companyName:
          this.corporateFlag || !user.business_account_flag
            ? user.company_name || ''
            : user.name01 + (user.name02 || ''),
        companyNameKana: this.corporateFlag ? '' : (user.kana01 || '') + (user.kana02 || ''),
        businessAccountFlag: user.business_account_flag || false,
      },
      shippingInformation: {
        addressId: null,
        deliveryDestination: this.Constants.DELIVERY_DESTINATION.SAME_MEMBER,
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        postalCode1: '',
        postalCode2: '',
        prefecture: null,
        municipality: '',
        address: '',
        buildingApartmentName: '',
        phoneNumber: '',
        shippingMethod: '',
        desiredDeliveryDay: this.$date
          .add(this.$date.startOfDay(new Date()), {
            days: 5, // EC-2697
          })
          .getTime(),
        desiredDeliveryTimeZone: null,
        delivery_note_id: null,
        bundled_flag: true,
        companyName: '',
        companyNameKana: '',
      },
      subscription: {
        deliveryPattern: this.Constants.DELIVERY_PATTERN.MONTHLY_DATE_SPECIFICATION,
        deliveryInterval: 1,
        secondDeliveryDate: 0,
      },
      paymentInformation: {
        methodOfPayment: this.$session[AMAZON.ACCESS_TOKEN_029] ? this.Constants.PAYMENT_METHOD.AMAZON : undefined, // default no choose payment method
        cardNumber: '',
        dateOfExpiredMonth: '',
        dateOfExpiredYear: '',
        cardHolder: null,
        securityCode: '',
        numberOfPayment: this.Constants.NUMBER_OF_PAYMENT.BULK,
        cardSeq: null,
        amazonCard: null,
      },
      placeFindThisProduct: '',
      advertisement_remarks: '',
    }
    const popupName = this.$route.query.popup

    const isPopupName = popupName && Object.values(this.Constants.POPUP_NAME).includes(popupName)

    const postalCodeValidator = async (rule, value, callback, section) => {
      const postalCode01 = this.form[section].postalCode1
      const postalCode02 = this.form[section].postalCode2

      if (postalCode01 && postalCode02 && isValidPostalCode({ postalCode01, postalCode02 })) {
        callback()
      } else if (
        (!postalCode01 && !postalCode02) ||
        !postalCode01 ||
        postalCode01.length < 3 ||
        !postalCode02 ||
        postalCode02.length < 4
      ) {
        callback(new Error(this.$t('common.validate.cmn-err-001', [this.$t('common.validate.field.postalCode')])))
      }
    }

    return {
      form: this.$_.cloneDeep(form),
      defaultForm: this.$_.cloneDeep(form),
      addressDialog: isPopupName && popupName === this.Constants.POPUP_NAME.ADDRESS,
      addresses: [],
      cardDialog: isPopupName && popupName === this.Constants.POPUP_NAME.CARD,
      cards: [],
      deliveryMethods: [],
      deliveryMinDate: null,
      section: {
        memberInfo: 'memberInfo',
        shippingInfo: 'shippingInfo',
        paymentInfo: 'paymentInfo',
      },
      isAvailableDeliveryTime: true,

      rules: {
        'memberInformation.lastName': [
          this.Utils.validate.required(this.$t('common.validate.field.lastName')),
          this.Utils.validate.shiftjis(this.$t('common.validate.shiftjis')),
        ],

        'memberInformation.firstName': [
          this.Utils.validate.required(this.$t('common.validate.field.firstName')),
          this.Utils.validate.shiftjis(this.$t('common.validate.shiftjis')),
        ],

        'memberInformation.lastNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.lastNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.lastNameKana')),
        ],

        'memberInformation.firstNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.firstNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.firstNameKana')),
        ],

        'memberInformation.birthdayYear': [
          this.Utils.validate.numberFormat(this.$t('common.validate.field.birthdayYear')),
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.birthdayYear')),
        ],

        'memberInformation.birthdayMonth': [
          this.Utils.validate.numberFormat(this.$t('common.validate.field.birthdayMonth')),
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.birthdayMonth')),
        ],

        'memberInformation.birthdayDay': [
          this.Utils.validate.numberFormat(this.$t('common.validate.field.birthdayDay')),
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.birthdayDay')),
        ],

        'memberInformation.sex': [this.Utils.validate.requiredSelect(this.$t('common.validate.field.sex'))],

        'memberInformation.email': [
          this.Utils.validate.required(this.$t('common.validate.field.email')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.email')),
        ],

        'memberInformation.emailConfirm': [
          this.Utils.validate.required(this.$t('common.validate.field.emailConfirm')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.emailConfirm')),
          {
            trigger: 'blur',
            validator: (_rule, value, callback) => {
              if (value !== this.form.memberInformation.email) {
                callback(
                  new Error(
                    this.$t('common.validate.cmn-err-015', [
                      this.$t('common.validate.field.email'),
                      this.$t('common.validate.field.emailConfirm'),
                    ])
                  )
                )
              } else {
                callback()
              }
            },
          },
        ],

        'memberInformation.password': !user.id
          ? [
              this.Utils.validate.required(this.$t('common.validate.field.password')),
              this.Utils.validate.password(this.$t('common.validate.field.password')),
            ]
          : [],
        'memberInformation.passwordConfirm': !user.id
          ? [
              this.Utils.validate.required(this.$t('common.validate.field.passwordConfirm')),
              this.Utils.validate.password(this.$t('common.validate.field.passwordConfirm')),
              {
                trigger: 'blur',
                validator: (_rule, value, callback) => {
                  if (value !== this.form.memberInformation.password) {
                    callback(
                      new Error(
                        this.$t('common.validate.cmn-err-015', [
                          this.$t('common.validate.field.password'),
                          this.$t('common.validate.field.passwordConfirm'),
                        ])
                      )
                    )
                  } else {
                    callback()
                  }
                },
              },
            ]
          : [],

        memberPostalCodeRule: [
          {
            validator: (rule, value, callback) => postalCodeValidator(rule, value, callback, 'memberInformation'),
            trigger: ['change', 'blur'],
          },
        ],

        'memberInformation.prefecture': [
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.prefecture')),
        ],

        'memberInformation.municipality': [this.Utils.validate.required(this.$t('common.validate.field.municipality'))],

        'memberInformation.address': [this.Utils.validate.required(this.$t('common.validate.field.address'))],

        'memberInformation.phoneNumber': [
          this.Utils.validate.required(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.phoneFormat(),
        ],
        'memberInformation.companyName': [this.Utils.validate.required(this.$t('common.validate.field.companyName'))],
        'memberInformation.companyNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.companyNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.companyNameKana')),
        ],
        'shippingInformation.lastName': [this.Utils.validate.required(this.$t('common.validate.field.lastName'))],

        'shippingInformation.firstName': [this.Utils.validate.required(this.$t('common.validate.field.firstName'))],

        'shippingInformation.lastNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.lastNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.lastNameKana')),
        ],

        'shippingInformation.firstNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.firstNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.firstNameKana')),
        ],

        shippingPostalCodeRule: [
          {
            validator: (rule, value, callback) => postalCodeValidator(rule, value, callback, 'shippingInformation'),
            trigger: ['change', 'blur'],
          },
        ],

        'shippingInformation.prefecture': [
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.prefecture')),
        ],

        'shippingInformation.municipality': [
          this.Utils.validate.required(this.$t('common.validate.field.municipality')),
        ],

        'shippingInformation.address': [this.Utils.validate.required(this.$t('common.validate.field.address'))],

        'shippingInformation.phoneNumber': [
          this.Utils.validate.required(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.phoneFormat(),
        ],
        'shippingInformation.companyName': [this.Utils.validate.required(this.$t('common.validate.field.companyName'))],
        'shippingInformation.companyNameKana': [
          this.Utils.validate.required(this.$t('common.validate.field.companyNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.companyNameKana')),
        ],

        'paymentInformation.methodOfPayment': [
          this.Utils.validate.requiredSelect(this.$t('common.validate.field.methodOfPayment')),
        ],

        'paymentInformation.cardNumber': [
          this.Utils.validate.required(this.$t('common.validate.field.cardNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.cardNumber')),
        ],

        'paymentInformation.dateOfExpiredMonth': [
          this.Utils.validate.required(this.$t('common.validate.field.dateOfExpiredMonth')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.dateOfExpiredMonth')),
          this.Utils.validate.numberBetween(this.$t('common.validate.field.dateOfExpiredMonth'), 1, 12),
        ],

        'paymentInformation.dateOfExpiredYear': [
          this.Utils.validate.required(this.$t('common.validate.field.dateOfExpiredYear')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.dateOfExpiredYear')),
          this.Utils.validate.numberBetween(
            this.$t('common.validate.field.dateOfExpiredYear'),
            new Date().getFullYear().toString().slice(-2),
            (new Date().getFullYear() + 10).toString().slice(-2)
          ),
        ],

        'paymentInformation.securityCode': [
          this.Utils.validate.required(this.$t('common.validate.field.securityCode')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.securityCode')),
        ],
      },
    }
  },
  computed: {
    days() {
      const daysInMonth = this.$date.getDaysInMonth(
        this.$date.set(new Date(), {
          year: this.form.memberInformation.birthdayYear,
          month: this.form.memberInformation.birthdayMonth - 1,
        })
      )

      return Array.from(Array(daysInMonth).keys()).map((index) => index + 1)
    },

    placeFindProducts() {
      return (
        this.$store.state.master.whereDidYouKnow?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || []
      )
    },

    sex() {
      return (
        this.$store.state.master.sex?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || []
      )
    },

    shippingMethods() {
      return this.deliveryMethods.length
        ? this.deliveryMethods
        : this.$store.state.register.shippingMethods?.map((item) => ({
            value: item.id,
            label: item.service_name,
          })) || []
    },

    paymentMethods() {
      return (
        this.$store.state.register.paymentMethods
          ?.map((item) => ({
            id: item.payment_service_id,
            value: item.id,
            label: item.payment_method,
            rule_max: item.rule_max,
          }))
          ?.filter((item) => item.id !== this.Constants.PAYMENT_METHOD.CASH_ON_DELIVERY) || []
      )
    },
    hasAmazonPayment() {
      return this.$store.state.register.paymentMethods?.some(
        (i) => i.payment_service_id === this.Constants.PAYMENT_METHOD.AMAZON
      )
    },
    postalCodeCustomer() {
      const postalCode = this.form.memberInformation.postalCode1 + '-' + this.form.memberInformation.postalCode2
      return postalCode.length === 8 ? postalCode : null
    },
    postalCodeShipping() {
      const postalCode = this.form.shippingInformation.postalCode1 + '-' + this.form.shippingInformation.postalCode2
      return postalCode.length === 8 ? postalCode : null
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },

  watch: {
    'form.memberInformation.birthdayYear'() {
      this.checkDateFeature()
    },
    'form.memberInformation.birthdayMonth'() {
      if (!this.days.includes(this.form.memberInformation.birthdayDay)) {
        this.form.memberInformation.birthdayDay = null
      }

      this.checkDateFeature()
    },
    'form.memberInformation.birthdayDay'() {
      this.checkDateFeature()
    },
    postalCodeCustomer(val) {
      if (
        val &&
        !this.user &&
        this.form.shippingInformation.deliveryDestination === this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      ) {
        this.updateDeliveryMethod(val)
        this.checkNotBundledRemoteIsland(val)
      } else {
        this.deliveryMethods = []
      }

      this.checkRemoteIsland(val)
    },
    postalCodeShipping(val) {
      if (
        val &&
        !this.user &&
        this.form.shippingInformation.deliveryDestination !== this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      ) {
        this.updateDeliveryMethod(val)
        this.checkNotBundledRemoteIsland(val)
      }

      this.checkRemoteIsland(val)
    },
    'form.memberInformation.prefecture'(val) {
      if (
        !this.user &&
        this.form.shippingInformation.deliveryDestination === this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      ) {
        this.updateMinDeliveryDate(this.postalCodeCustomer, val)
        this.checkNotBundledRemoteIsland(this.postalCodeCustomer)
      }
    },
    'form.shippingInformation.prefecture'(val) {
      if (
        !this.user &&
        this.form.shippingInformation.deliveryDestination !== this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      ) {
        this.updateMinDeliveryDate(this.postalCodeShipping, val)
        this.updateMinDeliveryDate(this.postalCodeShipping, this.form.shippingInformation.prefecture)
      }
    },
    'form.shippingInformation.shippingMethod'() {
      if (
        !this.user &&
        this.form.shippingInformation.deliveryDestination === this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      ) {
        this.updateMinDeliveryDate(this.postalCodeCustomer, this.form.memberInformation.prefecture)
        this.checkNotBundledRemoteIsland(this.postalCodeCustomer)
      } else {
        this.updateMinDeliveryDate(this.postalCodeShipping, this.form.shippingInformation.prefecture)
        this.checkNotBundledRemoteIsland(this.postalCodeShipping)
      }
    },
    'form.shippingInformation.deliveryDestination'() {
      this.isAvailableDeliveryTime = true
      if (
        !this.user &&
        this.form.shippingInformation.deliveryDestination === this.Constants.DELIVERY_DESTINATION.SAME_MEMBER
      ) {
        this.updateDeliveryMethod(this.postalCodeCustomer)
        this.updateMinDeliveryDate(this.postalCodeCustomer, this.form.memberInformation.prefecture)
        this.checkRemoteIsland(this.postalCodeCustomer)
        this.checkNotBundledRemoteIsland(this.postalCodeCustomer)
      } else {
        this.updateDeliveryMethod(this.postalCodeShipping)
        this.updateMinDeliveryDate(this.postalCodeShipping, this.form.shippingInformation.prefecture)
        this.checkRemoteIsland(this.postalCodeShipping)
        this.checkNotBundledRemoteIsland(this.postalCodeShipping)
      }
    },
  },

  created() {
    // Change default of ServiceId to PaymentId
    this.$nextTick(() => {
      this.form.paymentInformation.methodOfPayment = this.getPaymentIdByServiceId(
        this.form.paymentInformation.methodOfPayment
      )
    })
  },

  methods: {
    getPaymentIdByServiceId(serviceId) {
      return this.$store.state.register.paymentMethods.find((item) => item.payment_service_id === serviceId)?.id
    },
    getServiceIdByPaymentId(id) {
      return this.$store.state.register.paymentMethods.find((item) => item.id === id)?.payment_service_id
    },
    getInfoCustomer() {
      let postalCode = this.user.postal_code

      if (this.user.postal_code && !this.user.postal_code.includes(this.$t('common.hyphenSeparator'))) {
        const _code = this.user.postal_code.split('')
        _code.splice(3, 0, this.$t('common.hyphenSeparator'))
        postalCode = _code.join('')
      }

      const date = (this.user.birth && new Date(this.user.birth * 1000)) || null

      const [postalCode1, postalCode2] = postalCode?.split(this.$t('common.hyphenSeparator')) || ['', '']

      this.form.memberInformation = {
        lastName: this.user.name01 || '',
        firstName: this.user.name02 || '',
        lastNameKana: this.user.kana01 || '',
        firstNameKana: this.user.kana02 || '',
        birthdayYear: date ? this.$date.getYear(date) : null,
        birthdayMonth: date ? this.$date.getMonth(date) + 1 : null,
        birthdayDay: date ? this.$date.getDate(date) : null,
        sex: this.user.sex?.id || this.Constants.SEX.MALE,
        email: this.user.email || '',
        emailConfirm: this.user.email || '',
        password: this.user.password || '',
        passwordConfirm: this.user.password || '',
        postalCode1: postalCode1,
        postalCode2: postalCode2,
        prefecture: this.user.pref?.id || null,
        municipality: this.user.addr01 || '',
        address: this.user.addr02 || '',
        buildingApartmentName: this.user.addr03 || '',
        phoneNumber: this.Utils.helper.getOnlyNumber(this.user.phone_number),
        companyName: this.corporateFlag ? this.user.company_name || '' : this.user.name01 + (this.user.name02 || ''),
        companyNameKana: this.corporateFlag ? '' : this.user.kana01 + (this.user.kana02 || ''),
        businessAccountFlag: this.user.business_account_flag || false,
      }
    },
    checkRemoteIsland(postalCode) {
      MasterService.checkRemoteIsland(postalCode).then(({ data }) => {
        this.isAvailableDeliveryTime = data.time_zone

        this.form.shippingInformation.desiredDeliveryTimeZone = !this.isAvailableDeliveryTime ? undefined : null
      })
    },
    updateMinDeliveryDate(postalCode, prefId) {
      if (!this.form.shippingInformation.shippingMethod || !postalCode || !prefId) {
        this.deliveryMinDate = null
        this.form.shippingInformation.desiredDeliveryDay = add(startOfDay(new Date()), { days: 5 }).getTime()
      } else {
        DeliveryService.getDeliveryDateMin({
          id: this.form.shippingInformation.shippingMethod,
          pref_id: prefId,
          postal_code: postalCode,
        }).then(({ data }) => {
          this.form.shippingInformation.desiredDeliveryDay = startOfDay(data.delivery_date_start).getTime()
          this.deliveryMinDate = data.delivery_date_start
        })
      }
    },

    updateDeliveryMethod(postalCode) {
      if (postalCode) {
        DeliveryService.getDeliveryMethod(postalCode).then(({ data }) => {
          this.deliveryMethods = data.delivery_method.map((item) => ({
            value: item.id,
            label: item.service_name,
          }))
        })
      }

      this.form.shippingInformation.shippingMethod = this.shippingMethods[0].value
    },

    /**
     * Init when edit
     */
    initInfo() {
      const customer = this.$store.state.register.customer
      if (customer) {
        this.form = { ...customer }
      }
    },

    /**
     * Check date feature
     */
    checkDateFeature() {
      const { birthdayDay, birthdayMonth, birthdayYear } = this.form.memberInformation

      if (!birthdayDay || !birthdayMonth || !birthdayYear) return false

      const today = new Date()
      const birthday = new Date(birthdayYear, birthdayMonth - 1, birthdayDay)

      const isAfter = this.$date.isAfter(birthday, today)

      if (isAfter) {
        if (this.$date.getMonth(birthday) > this.$date.getMonth(today)) {
          this.form.memberInformation.birthdayMonth = 1
        }

        this.form.memberInformation.birthdayDay = 1

        this.$alert({
          message: this.$t('common.messages.selectDateFeature'),
          type: 'error',
        })

        return true
      }

      return false
    },
  },
}
